<div class="layout-auto-1-auto">
  <div class="app-section-header">
    <h2>Dashboard</h2>
  </div>
  <div class="content">
    <h6>{{getRessource('header.HeaderAuftrag')}} &lt;!&ndash;<i class="far fa-ellipsis-v md-btn-circular"></i>&ndash;&gt;
    </h6>
    <div class="dashboard-tile-container">
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide">
          <em>{{homeSummaryData.case.cFinal}}</em>
          <em>{{getRessource('case.cFinal')}}</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide-green">
          <em>{{homeSummaryData.case.cDone}}</em>
          <em>{{getRessource('case.cDone')}}</em>
          <em>
            {{calculatePercentage(homeSummaryData.case.cDone, homeSummaryData.case.cFinal)}} %</em>
        </div>
        <div class="dashboard-tile-small-wide-red">
          <em>{{homeSummaryData.case.cStorno}}</em>
          <em>{{getRessource('case.cStorno')}}</em>
          <em *ngIf="homeSummaryData.case.cStorno">
            {{calculatePercentage(homeSummaryData.case.cStorno, homeSummaryData.case.cFinal)}} %</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide">
          <em>{{homeSummaryData.case.cNotFinal}}</em>
          <em>{{getRessource('case.cNotFinal')}}</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide">
          <em>{{homeSummaryData.case.cWIP}}</em>
          <em>{{getRessource('case.cWIP')}}</em>
          <em *ngIf="homeSummaryData.case.cWIP">
            {{calculatePercentage(homeSummaryData.case.cWIP, homeSummaryData.case.cNotFinal)}} %</em>
        </div>
        <div class="dashboard-tile-small-wide-yellow">
          <em>{{homeSummaryData.case.cComplained}}</em>
          <em>{{getRessource('case.cComplained')}}</em>
          <em *ngIf="homeSummaryData.case.cComplained">
            {{calculatePercentage(homeSummaryData.case.cComplained, homeSummaryData.case.cNotFinal)}} %</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide">
          <em>{{homeSummaryData.case.cInvoicing}}</em>
          <em>{{getRessource('case.cInvoicing')}}</em>
          <em *ngIf="homeSummaryData.case.cInvoicing">
            {{calculatePercentage(homeSummaryData.case.cInvoicing, homeSummaryData.case.cNotFinal)}} %</em>
        </div>
      </div>
    </div>
    <app-exg-chart></app-exg-chart>
    <h6>{{getRessource('header.HeaderVorgang')}} &lt;!&ndash;<i class="far fa-ellipsis-v md-btn-circular"></i>&ndash;&gt;
    </h6>
    <div class="dashboard-tile-container">
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide">
          <em>{{homeSummaryData.task.cFinal}}</em>
          <em>{{getRessource('task.cFinal')}}</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide-green">
          <em>{{homeSummaryData.task.cDone}}</em>
          <em>{{getRessource('task.cDone')}}</em>
          <em *ngIf="homeSummaryData.task.cDone">
            {{calculatePercentage(homeSummaryData.task.cDone, homeSummaryData.task.cFinal)}} %
          </em>
        </div>
        <div class="dashboard-tile-small-wide-red">
          <em>{{homeSummaryData.task.cStorno}}</em>
          <em>{{getRessource('task.cStorno')}}</em>
          <em *ngIf="homeSummaryData.task.cStorno">
            {{calculatePercentage(homeSummaryData.task.cStorno, homeSummaryData.task.cFinal)}} %
          </em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide">
          <em>{{homeSummaryData.task.cNotFinal}}</em>
          <em>{{getRessource('task.cNotFinal')}}</em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide">
          <em>{{homeSummaryData.task.cWIP}}</em>
          <em>{{getRessource('task.cWIP')}}</em>
          <em *ngIf="homeSummaryData.task.cWIP">
            {{calculatePercentage(homeSummaryData.task.cWIP, homeSummaryData.task.cNotFinal)}} %
          </em>
        </div>
        <div class="dashboard-tile-small-wide-yellow">
          <em>{{homeSummaryData.task.cOpen}}</em>
          <em>{{getRessource('task.cOpen')}}</em>
          <em *ngIf="homeSummaryData.task.cOpen">
            {{calculatePercentage(homeSummaryData.task.cOpen, homeSummaryData.task.cNotFinal)}} %
          </em>
        </div>
      </div>
      <div class="dashboard-tile-container-medium-wide">
        <div class="dashboard-tile-small-wide">
          <em>{{homeSummaryData.task.cInvoicing}}</em>
          <em>{{getRessource('task.cInvoicing')}}</em>
          <em *ngIf="homeSummaryData.task.cInvoicing">
            {{calculatePercentage(homeSummaryData.task.cInvoicing, homeSummaryData.task.cNotFinal)}} %
          </em>
        </div>
        <div class="dashboard-tile-small-wide-red">
          <em>{{homeSummaryData.task.cEsk}}</em>
          <em>{{getRessource('task.cEsk')}}</em>
          <em *ngIf="homeSummaryData.task.cEsk">
            {{calculatePercentage(homeSummaryData.task.cEsk, homeSummaryData.task.cNotFinal)}} %
          </em>
        </div>
      </div>
    </div>
    <app-exg-chart></app-exg-chart>
    <span> {{getTestRessource('Test')}}</span>
  </div>
  <div></div>
</div>
